import { render, staticRenderFns } from "./company-shipping-card.vue?vue&type=template&id=f38e9e16&scoped=true&"
import script from "./company-shipping-card.vue?vue&type=script&lang=js&"
export * from "./company-shipping-card.vue?vue&type=script&lang=js&"
import style0 from "./company-shipping-card.vue?vue&type=style&index=0&id=f38e9e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38e9e16",
  null
  
)

export default component.exports